import useSWR from "swr";

import { baseApi } from "../common/envUtils";
import httpClient from "../providers/httpClient";

export function usePendingPhotoControlsCount() {
	const { data: pendingPhotoControlsCount, ...rest } = useSWR(
		"photoControlsCount",
		async () => {
			const filter = { status: [1] };
			const encodedFilter = encodeURIComponent(JSON.stringify(filter));
			const response = await httpClient(`${baseApi}/photo-controls?filter=${encodedFilter}`, {
				method: "GET",
			});
			if (!response || response.status !== 200) {
				return 0;
			}
			if (!response.json || !response.json.data || !Array.isArray(response.json.data)) {
				return 0;
			}
			return response.json.data.length;
		}
		// If we want to refresh it we can enable the refreshInterval
		// { refreshInterval: 4000 }
	);

	return { pendingPhotoControlsCount, ...rest };
}
